import { IS_IOS } from './device';

export const blockName = 'disable-page-scroll';
export const blockNameIOS = 'disable-page-scroll_ios';

let marginLeft = '';
let marginTop = '';

let scrollX = 0;
let scrollY = 0;

export function disablePageScroll() {
    console.log('Page scroll disabled');

    const { body } = document;
    body.classList.add(blockName);

    if (IS_IOS) {
        scrollX = window.scrollX;
        scrollY = window.scrollY;

        marginLeft = body.style.marginLeft;
        marginTop = body.style.marginTop;

        body.style.marginLeft = `-${scrollX}px`;
        body.style.marginTop = `-${scrollY}px`;

        body.classList.add(blockNameIOS);
    }
}

export function enablePageScroll() {
    console.log('Page scroll enabled');

    const { body } = document;
    body.classList.remove(blockName);

    if (IS_IOS) {
        body.classList.remove(blockNameIOS);

        body.style.marginLeft = marginLeft;
        body.style.marginTop = marginTop;

        window.scrollTo(scrollX, scrollY);
    }
}
